const authentication = require('../../../react-azure-adb2c2').default;


export const update = (value: any) => {
    // alert( JSON.stringify(value))

    // let url = `http://localhost:5000/api/v1/rent/contract/workflows/update/`+ value;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contract/workflows/update/`+ value;

    const token = authentication.getAccessToken();
    
    return fetch(url, {
        method: 'put',
        body: JSON.stringify({}),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};

export const update_contract_doc_at = (value: any) => {
    // alert( JSON.stringify(value))

    // let url = `http://localhost:5000/api/v1/rent/contract/workflows/updatedocat`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contract/workflows/updatedocat`;

    const token = authentication.getAccessToken();
    
    return fetch(url, {
        method: 'put',
        body: JSON.stringify(value),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};